import TimeDisplay from './TimeDisplay';

export { TimeDisplay };
export default TimeDisplay;
